export enum OfferPriceType {
    PURCHASE_PRICE,
    SELLING_PRICE,
    RECOMMENDED_PRICE,
}
